/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable()
export class GdprSchedulerService {
  private getGdprSchedularUrl: string = environment.host + '/getGdprSchedular';
  private saveGdprSchedularUrl: string = environment.host + '/saveGdprSchedular';
  private immediateSchedularUrl: string = environment.host + '/immediateGdprScheduler/';
  private gdprSchedulerHistoryUrl : string = environment.host + '/getGDPRSchedulerHistory';

  constructor(private http: HttpClient) {}

  public getGDPRSchedularData() {
    return this.http.get(this.getGdprSchedularUrl.toString()).toPromise();
  }

  public saveGDPRScheduler(gdprSchedulerObj: any) {
    return this.http.post(this.saveGdprSchedularUrl, gdprSchedulerObj).toPromise();
  }

  public immediateSchedule(immediateSchedulerObj: any, regionCode: string) {
    return this.http.post(this.immediateSchedularUrl + regionCode, immediateSchedulerObj).toPromise();
  }

  public gdprSchedulerHistory() {
    return this.http.get(this.gdprSchedulerHistoryUrl.toString()).toPromise();
  }
}
